import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import { useEffect, useMemo } from 'react'
import * as React from 'react'
import BlogCard from './BlogCard'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'
import { rem } from 'polished'
import styled from 'styled-components'
import { useAppDispatch } from 'hooks/reduxHooks'
import { fetchDreamSiteBlogPosts } from 'actions/ContentActions'
import { connect } from 'react-redux'
import { useIntl } from 'react-intl'

const BlogCarouselContainer = styled(LayoutContainer)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

const DREAM_SITE_HOMEPAGE_LOCATION = 'le-home-page'

interface Props {
  blogPosts?: Array<App.DreamSiteBlogPost>
}

function BlogCarousel(props: Props) {
  const dispatch = useAppDispatch()
  const intl = useIntl()

  useEffect(() => {
    dispatch(fetchDreamSiteBlogPosts(DREAM_SITE_HOMEPAGE_LOCATION, 3))
  }, [dispatch])

  const { blogPosts } = props

  const headingText = useMemo(
    () =>
      intl.formatMessage(
        {
          id: 'BB-zU2nHpnoq4WEhGyBl',
          defaultMessage: 'Be <i>inspired</i> for your next adventure',
          description: 'Blog carousel heading with italicized word "inspired"',
        },
        {
          i: (chunks: React.ReactNode) => <i key="italic">{chunks}</i>,
        },
      ),
    [intl],
  )

  const viewAllText = intl.formatMessage({
    id: 'aP2qL6PWUsIoy_qm6R49',
    defaultMessage: 'View all',
    description: 'Action button label to view all blog posts on the homepage',
  })

  const descriptionText = intl.formatMessage({
    id: 'QXSlzwKu60GLES7Sie6U',
    defaultMessage: 'Dream with our collection of articles and local travel trips',
    description: 'Blog carousel description text in the trip planner feature',
  })

  return (<BlogCarouselContainer data-testid="blog-carousel">
    <Group direction="vertical" gap={8}>
      <Group
        direction="horizontal"
        horizontalAlign="space-between"
        gap={16}
      >
        <Heading variant="heading2">
          {headingText}
        </Heading>
        <TextButton kind="tertiary" size="medium" href="https://luxuryescapes.com/inspiration/" target="_blank">
          {viewAllText}
        </TextButton>
      </Group>
      <BodyText variant="large">
        {descriptionText}
      </BodyText>
      <CardCarousel pageSize={3}>
        {blogPosts?.map((blogPost) => (
          <BlogCard
            key={blogPost.id}
            image={{
              url: blogPost.image.url,
            }}
            title={blogPost.title}
            description={blogPost.shortDescription}
            url={blogPost.url}
          />
        ))}
      </CardCarousel>
    </Group>
  </BlogCarouselContainer>
  )
}

function mapStateToProps(state: App.State) {
  return {
    blogPosts: state.content.dreamSiteBlogPosts[DREAM_SITE_HOMEPAGE_LOCATION],
  }
}

export default connect(mapStateToProps)(BlogCarousel)
